import { useState } from "react";

const DEGISKENLER = [
  { key: "%veli_adi", aciklama: "Velinin adı soyadı" },
  { key: "%ogrenci_adi", aciklama: "Öğrencinin adı soyadı" },
  { key: "%telefon", aciklama: "Velinin telefon numarası" },
  { key: "%odeme_tarihi", aciklama: "Aylık ödeme tarihi" },
  { key: "%taahhut_bitis_tarihi", aciklama: "Taahhüt bitiş tarihi" },
  { key: "%kampanya_adi", aciklama: "Aktif kampanya adı" },
  { key: "%son_tarih", aciklama: "Son başvuru / son geçerlilik tarihi" },
  { key: "%duraklatma_formu", aciklama: "GoStudent duraklatma form bağlantısı" },
];

export default function AyarlarPage() {
  const [danismanAd, setDanismanAd] = useState("Selin Yıldırım");
  const [firmaAd, setFirmaAd] = useState("GoStudent Türkiye");
  const [telefon, setTelefon] = useState("0532 000 11 22");
  const [eposta, setEposta] = useState("selin@gostudent.com");
  const [aralik, setAralik] = useState("6");
  const [limitSayisi, setLimitSayisi] = useState("50");
  const [sistemAktif, setSistemAktif] = useState(true);
  const [testNumara, setTestNumara] = useState("0532 999 88 77");
  const [eskiSifre, setEskiSifre] = useState("");
  const [yeniSifre, setYeniSifre] = useState("");
  const [yeniSifreTekrar, setYeniSifreTekrar] = useState("");
  const [bildirimOdeme, setBildirimOdeme] = useState(true);
  const [bildirimReferans, setBildirimReferans] = useState(true);
  const [bildirimTaahhut, setBildirimTaahhut] = useState(false);
  const [saved, setSaved] = useState(false);
  const [copiedKey, setCopiedKey] = useState<string | null>(null);

  const handleSave = () => {
    setSaved(true);
    setTimeout(() => setSaved(false), 2500);
  };

  const handleCopy = (key: string) => {
    navigator.clipboard.writeText(key).catch(() => {});
    setCopiedKey(key);
    setTimeout(() => setCopiedKey(null), 1500);
  };

  return (
    <div className="p-4 md:p-6 xl:p-8 space-y-6 max-w-3xl">
      <div>
        <h2 className="text-xl font-bold text-gray-900">Ayarlar</h2>
        <p className="text-sm text-gray-500 mt-0.5">Sistem, danışman ve WhatsApp gönderim ayarlarınızı yapılandırın</p>
      </div>

      {/* 1 - Danışman Bilgileri */}
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-3">
          <div className="w-8 h-8 rounded-xl bg-[#0B1120] flex items-center justify-center">
            <i className="ri-user-settings-line text-white text-sm"></i>
          </div>
          <h3 className="text-sm font-bold text-gray-900">Firma / Danışman Bilgileri</h3>
        </div>
        <div className="p-6 grid grid-cols-1 sm:grid-cols-2 gap-4">
          {[
            { label: "Ad Soyad", value: danismanAd, setter: setDanismanAd, placeholder: "Ad soyad" },
            { label: "Firma Adı", value: firmaAd, setter: setFirmaAd, placeholder: "Firma adı" },
            { label: "Telefon", value: telefon, setter: setTelefon, placeholder: "0500 000 00 00" },
            { label: "E-posta", value: eposta, setter: setEposta, placeholder: "ornek@email.com" },
          ].map(f => (
            <div key={f.label}>
              <label className="block text-xs font-semibold text-gray-600 mb-1.5">{f.label}</label>
              <input
                value={f.value}
                onChange={e => f.setter(e.target.value)}
                placeholder={f.placeholder}
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
              />
            </div>
          ))}
        </div>
      </div>

      {/* 2 - WhatsApp Gönderim Ayarları */}
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-3">
          <div className="w-8 h-8 rounded-xl bg-[#25D366] flex items-center justify-center">
            <i className="ri-whatsapp-line text-white text-sm"></i>
          </div>
          <h3 className="text-sm font-bold text-gray-900">WhatsApp Gönderim Ayarları</h3>
        </div>
        <div className="p-6 space-y-5">
          {/* Sistem Aktif */}
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
            <div className="flex items-center gap-3">
              <div className={`w-9 h-9 rounded-xl flex items-center justify-center ${sistemAktif ? "bg-[#25D366]/10" : "bg-gray-200"}`}>
                <i className={`ri-robot-line text-sm ${sistemAktif ? "text-[#25D366]" : "text-gray-400"}`}></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-800">Aktif Gönderim Sistemi</p>
                <p className="text-xs text-gray-500">Otomatik mesaj gönderimini açar/kapatır</p>
              </div>
            </div>
            <button
              onClick={() => setSistemAktif(!sistemAktif)}
              className={`relative w-12 h-6 rounded-full transition-colors cursor-pointer flex-shrink-0 ${sistemAktif ? "bg-[#25D366]" : "bg-gray-300"}`}
            >
              <div className={`absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ${sistemAktif ? "translate-x-6" : "translate-x-0.5"}`} />
            </button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                Varsayılan Gönderim Aralığı (dakika)
              </label>
              <input
                type="number"
                value={aralik}
                onChange={e => setAralik(e.target.value)}
                min={1}
                max={60}
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                Günlük Maksimum Gönderim
              </label>
              <input
                type="number"
                value={limitSayisi}
                onChange={e => setLimitSayisi(e.target.value)}
                min={1}
                max={500}
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-gray-600 mb-1.5">
                Test Numarası
              </label>
              <input
                value={testNumara}
                onChange={e => setTestNumara(e.target.value)}
                placeholder="0500 000 00 00"
                className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
              />
            </div>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 flex items-start gap-3">
            <div className="w-5 h-5 flex items-center justify-center text-amber-600 flex-shrink-0 mt-0.5">
              <i className="ri-information-line text-sm"></i>
            </div>
            <p className="text-xs text-amber-700">
              Gönderim aralığı artırıldığında günlük gönderim kapasitesi düşer. Önerilen değer <strong>6 dakika</strong> olup günde ~240 mesaj kapasitesi sağlar.
            </p>
          </div>
        </div>
      </div>

      {/* 3 - Mesaj Değişkenleri */}
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-3">
          <div className="w-8 h-8 rounded-xl bg-sky-500 flex items-center justify-center">
            <i className="ri-code-line text-white text-sm"></i>
          </div>
          <h3 className="text-sm font-bold text-gray-900">Mesaj Değişkenleri</h3>
        </div>
        <div className="p-6">
          <p className="text-xs text-gray-500 mb-4 leading-relaxed">
            Bu değişkenleri mesaj şablonlarında kullanabilirsiniz. Gönderim sırasında otomatik olarak kişiye özel verilerle doldurulur.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {DEGISKENLER.map(d => (
              <div
                key={d.key}
                className="flex items-center justify-between p-3 bg-gray-50 rounded-xl border border-gray-100 group"
              >
                <div className="flex items-center gap-3">
                  <span className="font-mono text-xs font-bold text-[#25D366] bg-[#0B1120] px-2 py-1 rounded-lg whitespace-nowrap">
                    {d.key}
                  </span>
                  <span className="text-xs text-gray-600">{d.aciklama}</span>
                </div>
                <button
                  onClick={() => handleCopy(d.key)}
                  title="Kopyala"
                  className="w-7 h-7 flex items-center justify-center rounded-lg bg-white border border-gray-200 text-gray-400 hover:text-gray-700 cursor-pointer opacity-0 group-hover:opacity-100 transition-all"
                >
                  <i className={`${copiedKey === d.key ? "ri-check-line text-emerald-500" : "ri-clipboard-line"} text-xs`}></i>
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* 4 - Kullanıcı ve Güvenlik */}
      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-100 flex items-center gap-3">
          <div className="w-8 h-8 rounded-xl bg-red-500 flex items-center justify-center">
            <i className="ri-shield-keyhole-line text-white text-sm"></i>
          </div>
          <h3 className="text-sm font-bold text-gray-900">Kullanıcı ve Güvenlik</h3>
        </div>
        <div className="p-6 space-y-5">
          {/* Şifre değiştir */}
          <div>
            <p className="text-xs font-bold text-gray-700 mb-3">Şifre Değiştir</p>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              {[
                { label: "Mevcut Şifre", value: eskiSifre, setter: setEskiSifre },
                { label: "Yeni Şifre", value: yeniSifre, setter: setYeniSifre },
                { label: "Yeni Şifre (Tekrar)", value: yeniSifreTekrar, setter: setYeniSifreTekrar },
              ].map(f => (
                <div key={f.label}>
                  <label className="block text-xs font-semibold text-gray-600 mb-1.5">{f.label}</label>
                  <input
                    type="password"
                    value={f.value}
                    onChange={e => f.setter(e.target.value)}
                    placeholder="••••••••"
                    className="w-full px-4 py-2.5 text-sm border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#25D366]/30 focus:border-[#25D366]"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Oturum */}
          <div className="p-4 bg-gray-50 rounded-xl flex items-center justify-between">
            <div>
              <p className="text-sm font-semibold text-gray-800">Oturum Bilgileri</p>
              <p className="text-xs text-gray-500 mt-0.5">Son giriş: 2026-05-19 09:14 – IP: 192.168.1.100</p>
            </div>
            <button className="px-3 py-1.5 text-xs font-semibold text-red-600 border border-red-200 rounded-xl hover:bg-red-50 cursor-pointer whitespace-nowrap transition-colors">
              Çıkış Yap
            </button>
          </div>

          {/* Bildirim tercihleri */}
          <div>
            <p className="text-xs font-bold text-gray-700 mb-3">Bildirim Tercihleri</p>
            <div className="space-y-3">
              {[
                { label: "Ödeme hatırlatmalarında bildirim al", desc: "Ödeme günü gelen uyarılar", value: bildirimOdeme, setter: setBildirimOdeme },
                { label: "Referans isteme mesajlarında bildirim al", desc: "Referans kampanya güncellemeleri", value: bildirimReferans, setter: setBildirimReferans },
                { label: "Taahhüt bitiş uyarılarında bildirim al", desc: "30 gün içinde bitecek taahhütler", value: bildirimTaahhut, setter: setBildirimTaahhut },
              ].map(b => (
                <div key={b.label} className="flex items-center justify-between p-3 rounded-xl border border-gray-100 hover:bg-gray-50 transition-colors">
                  <div>
                    <p className="text-sm font-medium text-gray-800">{b.label}</p>
                    <p className="text-xs text-gray-500">{b.desc}</p>
                  </div>
                  <button
                    onClick={() => b.setter(!b.value)}
                    className={`relative w-10 h-5 rounded-full transition-colors cursor-pointer flex-shrink-0 ${b.value ? "bg-[#25D366]" : "bg-gray-200"}`}
                  >
                    <div className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${b.value ? "translate-x-5" : "translate-x-0.5"}`} />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Save */}
      <div className="flex items-center justify-between bg-white rounded-2xl border border-gray-100 px-6 py-4">
        {saved && (
          <div className="flex items-center gap-2 text-emerald-600">
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-checkbox-circle-line text-base"></i>
            </div>
            <span className="text-sm font-semibold">Ayarlar kaydedildi!</span>
          </div>
        )}
        {!saved && <div />}
        <button
          onClick={handleSave}
          className="px-6 py-2.5 text-sm bg-[#0B1120] text-white rounded-xl hover:bg-[#1a2a4a] cursor-pointer font-semibold whitespace-nowrap transition-colors"
        >
          Ayarları Kaydet
        </button>
      </div>
    </div>
  );
}